"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = void 0;
var accountApi = _interopRequireWildcard(require("./accountApi"));
var _utils = _interopRequireWildcard(require("./utils"));
var utils = _utils;
var skyusersApi = _interopRequireWildcard(require("./skyusersApi"));
var tokenUtils = _interopRequireWildcard(require("./tokenData"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Store {
  static instance = null;
  state = "initializing";
  baseExpirationThreshold = (() => 5 * 60 * 1000)();
  expirationThreshold;
  initializationPromise;
  tokenData = (() => tokenUtils.emptyTokenData())();
  userData = null;
  refreshPromise = null;
  constructor() {
    utils.log("store constructor 20250428-2137");
    this.initializationPromise = this.initializeInternal();

    // adjust expiration threshold based on random number between 0 - 20 seconds
    // to avoid multiple tabs refreshing at the same time
    const randomInterval = Math.floor(Math.random() * 20) * 1000;
    this.expirationThreshold = this.baseExpirationThreshold + randomInterval;
  }
  static getInstance() {
    if (Store.instance === null) {
      const temp = new Store();
      Store.instance = temp;
    }
    return Store.instance;
  }
  async getState() {
    await this.ensureInitialized();
    await this.synchronizeTokenData();
    return this.state;
  }
  async getAccessToken() {
    await this.ensureInitialized();
    await this.synchronizeTokenData();
    if (typeof this.tokenData.accessToken.data === "string") {
      // always return legacy token
      if (this.tokenData.accessToken.isLegacy) {
        // maybe exchange legacy token
        return this.tokenData.accessToken.data;
      }

      // check if token is expiring soon
      const isExpiring = tokenUtils.isTokenExpiring(this.tokenData, this.expirationThreshold);
      if (isExpiring) {
        await this.safeRefreshToken();
      }
    }
    return this.tokenData.accessToken.data;
  }
  async getUserData() {
    var _this$userData;
    await this.ensureInitialized();
    return (_this$userData = this.userData) !== null && _this$userData !== void 0 ? _this$userData : null;
  }
  async login(_ref) {
    let {
      accessToken,
      refreshToken
    } = _ref;
    await this.ensureInitialized();
    // Only proceed if we're logged out
    if (this.state !== "loggedOut") {
      return;
    }
    try {
      // Try to get user data with the new token
      const userData = await accountApi.getUser(accessToken);
      if (userData === null) {
        this.state = "loggedOut";
      } else {
        // Set both token and user data atomically
        this.tokenData = tokenUtils.processTokens(accessToken, refreshToken);
        this.userData = userData;
        await tokenUtils.save(this.tokenData);
        this.state = "loggedIn";
      }
    } catch (error) {
      utils.logError("Failed to login:", error);
      this.state = "loggedOut";
    }
  }
  async logout() {
    await this.ensureInitialized();
    if (this.state === "loggedIn") {
      const token = this.tokenData.accessToken;
      if (typeof token === "string") {
        try {
          await skyusersApi.logout(token);
        } catch (error) {
          utils.logError("Failed to logout:", error);
        }
      }
    }
    await tokenUtils.clear();
    this.clearData();
  }
  clearData() {
    this.tokenData = tokenUtils.emptyTokenData();
    this.userData = null;
    this.state = "loggedOut";
  }
  async initializeInternal() {
    try {
      const tokenData = await this.initializeTokens();
      if (tokenData.accessToken.data !== null) {
        await this.initializeUserData(tokenData.accessToken.data);
      }
    } catch (error) {
      utils.logError("Failed to initialize store:", error);
      this.state = "loggedOut";
    }
  }
  async ensureInitialized() {
    await this.initializationPromise;
  }
  async initializeTokens() {
    this.tokenData = await tokenUtils.get();
    if (this.tokenData.accessToken.isLegacy) {
      this.tokenData = await tokenUtils.refresh(this.tokenData);
    }
    await this.refreshToken();
    if (this.tokenData.accessToken.data === null) {
      this.state = "loggedOut";
    } else {
      this.state = "loggedIn";
    }
    return this.tokenData;
  }
  async initializeUserData(accessToken) {
    const userData = await accountApi.getUser(accessToken);
    if (userData === null) {
      await this.logout();
      return null;
    }
    this.userData = userData;
    return userData;
  }
  async synchronizeTokenData() {
    // make sure sync with cookies if in browser
    if (!(0, _utils.isWebview)()) {
      const tokenData = await tokenUtils.get();
      const validToken = typeof tokenData.accessToken.data === "string";
      if (validToken && this.state === "loggedIn") {
        // we are logged in and the token is present we just update token
        if (this.tokenData !== tokenData) {
          this.tokenData = tokenData;
        }
      } else if (validToken && this.state === "loggedOut") {
        this.state = "loggedIn";
      } else if (!validToken && this.state === "loggedIn") {
        // we are logged in and the token is not present we logout
        await this.logout();
      }
    }
  }
  async refreshToken() {
    await this.synchronizeTokenData();
    try {
      const isExpiring = tokenUtils.isTokenExpiring(this.tokenData, this.expirationThreshold);
      if (isExpiring) {
        this.tokenData = await tokenUtils.refresh(this.tokenData);
      }
    } catch (error) {
      utils.logError("Failed to refresh token:", error);
      await this.logout();
    }
  }
  async safeRefreshToken() {
    await this.ensureInitialized();

    // return the promise if it exists
    if (this.refreshPromise !== null) {
      return this.refreshPromise;
    }
    const inner = async () => {
      // double check promise lock
      if (this.refreshPromise) {
        return this.refreshPromise;
      }
      // never throw error, always return null
      try {
        // here the actual refresh will be done
        await this.refreshToken();
      } catch (error) {
        // catch all errors just in case this.refreshToken() throws an error
        utils.logError("Failed to refresh token:", error);
        await this.logout();
      }
      return Promise.resolve();
    };

    // Create a new refresh promise
    const outer = (async () => {
      await inner();
      // clean the promise locks and return the result
      this.refreshPromise = null;
    })();

    // Set the promise reference atomically with a unique identifier
    this.refreshPromise = outer;
    return outer;
  }
}

// Export singleton instance
const store = exports.store = Store.getInstance();